import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { routes } from "src/routes";
import KudosContext from "src/context";

export class ProtectedComponent extends React.Component<RouteProps> {
  public static contextType = KudosContext;
  public context!: React.ContextType<typeof KudosContext>;

  public componentDidMount() {
    this.context!.fetchProfile();
  }

  public render() {
    const isAuthenticated = !!this.context!.profile;

    if (this.context!.authInProgress) {
      return null;
    } else {
      return (
        <Route
          render={() =>
            this.renderComponent(this.props.component, isAuthenticated)
          }
        />
      );
    }
  }

  public renderComponent = (Component, isAuthenticated: boolean) => {
    return isAuthenticated ? (
      <Component {...this.props} />
    ) : (
      <Redirect to={routes.login} />
    );
  };
}
